import { IconKey ,IconGraph} from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconGraph
};
//

const Analytics = {

    id: 'analytics',
    title: 'Analytics',
    type: 'group',
    display_id:'I',
    icon: icons.IconGraph,
    children: [
        {
            id: 'analytics_dashboard',
            title: 'Dashboard',
            type: 'item',
            display_id:53,
            url: '/Department/Analytics',
            breadcrumbs: false
        },
    ]
}

export default Analytics;
